export const AUTHORIZING_URL = '/session';
export const AUTH_TYPE_EDGE = 'edge';
